import * as angular from "angular";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Limit } from "../../models/limit.model";
import { DialogUtils } from "../../helper/dialog.helper";

let HiddenInfoComponent = {
    selector: "vcHiddenInfo",
    templateUrl: "/angular/components/activity/hidden-info.component.html",
    bindings: {},
    controller: class HiddenInfoController {
        public canvassLimit: number;
        private dialog: DialogUtils;

        private $window: any;
        public __env: any;

        constructor(
            __env: any,
            $window: any,
            DialogUtils: DialogUtils,
            LimitDataProvider: LimitDataProvider
        ) {
            this.dialog = DialogUtils;
            this.__env = __env;
            this.$window = $window;

            LimitDataProvider.get().then((accountLimits: Limit) => {
                this.canvassLimit = accountLimits.canvasslimit;
            });
        }

        openIntercomChat(): void {
            this.$window.Intercom("showNewMessage");
        }

        closeDialog(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("activity")
    .component(HiddenInfoComponent.selector, HiddenInfoComponent);
